/* YM cart recs quick-add. Adds 1 unit via /cart/add.js, then lets the theme + ym-free-shipping-bar.js refresh. */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ym-recs-add]');
    if (!btn) return;
    e.preventDefault();
    var props = { _ym_src: btn.dataset.ymSrc || 'cart_rec' }; if (btn.dataset.ymTrigger) props._ym_trigger = btn.dataset.ymTrigger;
    btn.disabled = true; btn.textContent = 'Adding…';
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.ymRecsAdd), quantity: 1, properties: props }] })
    }).then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () {
        if (window.dataLayer) dataLayer.push({ event: 'ym_cart_rec_add', ym_rec_src: props._ym_src, ym_rec_handle: btn.dataset.product, ym_rec_trigger: btn.dataset.ymTrigger || '' });
        document.dispatchEvent(new CustomEvent('ym:cart:updated'));
        if (document.querySelector('.ym-recs--page')) { window.location.reload(); return; }
        /* drawer: re-render Halo's side cart (same view Halo uses), else reload */
        var wrap = document.querySelector('#halo-cart-sidebar .previewCart-wrapper');
        if (!wrap) { window.location.reload(); return; }
        var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
        Promise.all([fetch(root + 'cart?view=ajax_side_cart', { cache: 'no-store' }).then(function (r) { if (!r.ok) throw r; return r.text(); }),
                     fetch(root + 'cart.js').then(function (r) { return r.json(); })])
          .then(function (res) {
            wrap.innerHTML = res[0];
            if (btn.dataset.ymSrc === 'pdp_rec') { btn.disabled = false; btn.textContent = 'Added \u2713'; document.body.classList.add('cart-sidebar-show'); }
            document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = res[1].item_count; });
            document.dispatchEvent(new CustomEvent('ym:cart:updated'));
          }).catch(function () { window.location.reload(); });
      })
      .catch(function () { btn.disabled = false; btn.textContent = 'Try again'; });
  });
})();

/* v2: PDP rec card per-option picker */
(function () {
  function data(card) { if (!card._ymv) { var el = card.querySelector('[data-ym-variants]'); card._ymv = el ? JSON.parse(el.textContent) : []; } return card._ymv; }
  function sel(card) { return [].map.call(card.querySelectorAll('[data-ym-opt]'), function (o) { var s = o.querySelector('select'); if (s) return s.value; var a = o.querySelector('.ym-recs__pill.is-active'); return a ? a.dataset.val : null; }); }
  function setVal(card, oi, val) {
    var o = card.querySelector('[data-ym-opt="' + oi + '"]'), s = o.querySelector('select');
    if (s) { s.value = val; s.title = val; } else o.querySelectorAll('.ym-recs__pill').forEach(function (x) { var on = x.dataset.val === val; x.classList.toggle('is-active', on); x.setAttribute('aria-pressed', on); });
  }
  function match(v, cur) { return cur.every(function (c, i) { return v.o[i] === c; }); }
  function refresh(card, changed) {
    var vs = data(card), cur = sel(card);
    var v = vs.filter(function (x) { return x.a && match(x, cur); })[0];
    if (!v) { // keep changed option, pick cheapest available with it
      var c = vs.filter(function (x) { return x.a && x.o[changed] === cur[changed]; }).sort(function (a, b) { return parseFloat(a.p.replace(/[^0-9.]/g, '')) - parseFloat(b.p.replace(/[^0-9.]/g, '')); })[0];
      if (c) { c.o.forEach(function (val, i) { setVal(card, i, val); }); v = c; cur = c.o.slice(); }
    }
    // grey out values with no available variant given the other selections
    card.querySelectorAll('[data-ym-opt]').forEach(function (o) {
      var oi = +o.dataset.ymOpt;
      [].forEach.call(o.querySelectorAll('.ym-recs__pill, option'), function (el) {
        var val = el.dataset.val || el.value;
        var ok = vs.some(function (x) { return x.a && x.o[oi] === val && cur.every(function (c, i) { return i === oi || x.o[i] === c; }); });
        el.classList.toggle('is-na', !ok); if (el.tagName === 'OPTION') el.textContent = el.textContent.replace(/ \(sold out\)$/, '') + (ok ? '' : ' (sold out)');
        else el.setAttribute('aria-disabled', !ok);
      });
    });
    var add = card.querySelector('[data-ym-recs-add]');
    if (v) { add.setAttribute('data-ym-recs-add', v.id); add.disabled = false; add.textContent = '+ Add';
      var pr = card.querySelector('[data-ym-price]'); if (pr) pr.textContent = v.p;
      var im = card.querySelector('[data-ym-img]'); if (im && v.i) { im.src = v.i; im.removeAttribute('srcset'); } }
    else { add.disabled = true; add.textContent = 'Sold out'; }
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.ym-recs__pill[data-val]'); if (!b) return;
    var card = b.closest('.ym-recs__card'), oi = +b.closest('[data-ym-opt]').dataset.ymOpt;
    setVal(card, oi, b.dataset.val); refresh(card, oi);
  });
  document.addEventListener('change', function (e) {
    var s = e.target.closest('[data-ym-opt] select'); if (!s) return;
    var card = s.closest('.ym-recs__card'), oi = +s.closest('[data-ym-opt]').dataset.ymOpt;
    s.title = s.value; refresh(card, oi);
  });
  function init() { document.querySelectorAll('.ym-recs--pdp .ym-recs__card').forEach(function (c) { if (c.querySelector('[data-ym-opt]')) refresh(c, 0); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
